import Panel from "../components/common/Panel";
import Seo from "../components/common/Seo";
import { t } from "../i18n/messages";
import { useAppState } from "../state/AppStateProvider";
import { buildPath } from "../utils/routing";

export default function RwaPage({ locale }) {
  const { assets, assetsLoading } = useAppState();

  return (
    <>
      <Seo
        locale={locale}
        title={`Chronos Arte Node | ${t(locale, "navRwa")}`}
        description={t(locale, "rwaDesc")}
        path={buildPath(locale, "rwa")}
      />

      <Panel title={t(locale, "navRwa")} description={t(locale, "rwaPanelDesc")}>
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>{t(locale, "rwaColAsset")}</th>
                <th>{t(locale, "rwaColCustody")}</th>
                <th>{t(locale, "rwaColAppraisal")}</th>
                <th>{t(locale, "rwaColValuation")}</th>
                <th>{t(locale, "rwaColUpdated")}</th>
              </tr>
            </thead>
            <tbody>
              {assetsLoading ? (
                <tr>
                  <td colSpan={5}>{t(locale, "rwaLoading")}</td>
                </tr>
              ) : assets.length ? (
                assets.map((item) => (
                  <tr key={item.id}>
                    <td>{item.name}</td>
                    <td>{item.proof?.custodyHash || "-"}</td>
                    <td>{item.proof?.appraisalHash || "-"}</td>
                    <td>{item.proof?.valuationHash || "-"}</td>
                    <td>{item.proof?.updatedAtIso || "-"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={5}>{t(locale, "rwaNoAssets")}</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Panel>
    </>
  );
}
